import { configureStore } from "@reduxjs/toolkit";
import mspReducer from "../features/msp/slices/mspSlice";
import selectedMspReducer from "../features/msp/slices/selectedMspSlice";
import selectedCustomerReducer from "../features/msp/slices/selectedCustomerSlice";
import apiStatusReducer from "../features/msp/slices/apiStatusSlice";

export const store = configureStore({
  reducer: {
    msp: mspReducer,
    selectedMsp: selectedMspReducer,
    selectedCustomer: selectedCustomerReducer,
    apiStatus: apiStatusReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
